import { TokenManager, TokenStorage } from '@forgerock/javascript-sdk';
import { saveTokens, getRefreshToken, clearTokens } from '../utils/tokenStorage';
import { getClientIdFromHostname, getEnvironmentFromHost } from '../utils/UserUtils';



// ── Refresh access token ─────────────────────────────────────────────
export const refreshAccessToken = async () => {


  const environment = getEnvironmentFromHost().toUpperCase();
  const hostname = window.location?.hostname;
  const clientId = getClientIdFromHostname(hostname, environment);
  var BASE_URL = process.env[`REACT_APP_${environment.toUpperCase()}_IAM_URL`]
  const REALM_PATH = process.env[`REACT_APP_${environment.toUpperCase()}_REALM_PATH`];

  const tokenUrl = `${BASE_URL}oauth2/realms/root/realms/${REALM_PATH}/access_token`;

  const token = await TokenManager.getTokens();
  const refresh_token = getRefreshToken();

  if (!token.refreshToken) throw new Error('No refresh token available');

  const params = new URLSearchParams({
    grant_type: 'refresh_token',
    client_id: clientId,
    refresh_token: token.refreshToken,
    // refresh_token: refresh_token,
    scope: 'openid profile',
  });

  const response = await fetch(`${tokenUrl}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: params.toString(),
  });

  if (!response.ok) {
    clearTokens();
    throw new Error('Refresh token expired — re-login required');
  }

  const data = await response.json();
  // Normalize field names and convert expires_in → absolute epoch
  const normalizedTokens = {
    accessToken: data.access_token,
    idToken: data.id_token,
    refreshToken: data.refresh_token,
    tokenExpiry: Date.now() + (data.expires_in * 1000), //  ms epoch
  };
  //axios.defaults.headers.common['token'] = normalizedTokens.idToken;
  // ForgeRock rotates refresh token — always save the new one
  // await TokenManager.set(data);
  await TokenStorage.set(normalizedTokens);

  saveTokens(data);

  return normalizedTokens;
};